import { useMutation } from '@apollo/client';
import { Col, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { CustomNotification } from 'src/components/custom-notification';
import { ROUTES } from 'src/config/route';

import { CreateSlider as CreateSliderM } from 'src/lib/gql/mutations';
import SliderCard from '../../components/ui/sliders/slider-card';
import {
	CmsCreateSliderMutationMutation,
	CmsCreateSliderMutationMutationVariables,
} from 'src/lib/generated/_generated';

const CreateSlider = () => {
	const [createSlider] = useMutation<
		CmsCreateSliderMutationMutation,
		CmsCreateSliderMutationMutationVariables
	>(CreateSliderM, {
		onError(error) {
			CustomNotification({
				pageName: 'Sliders',
				pagePrefix: 'Slider',
				notificationType: 'custom-error',
				customDescription: error.message,
			});
		},
	});

	const navigate = useNavigate();
	return (
		<Row>
			<Col span={24}>
				<Text className="sub-header">Create Slider</Text>
			</Col>

			<SliderCard
				inclSliderPosition={true}
				onSave={async (data) => {
					const rsp = await createSlider({
						variables: {
							sliderDates:
								data.dates.map((date) => format(date, 'yyyy-MM-dd')) || [],
							sliderHTags: data.tags || [],
							mediaId: data.mediaId,
							venueId: data.venueId,
							weight: data.position,
							link: data.link,
							mediaType: data.mediaType,
							title: data.name || '',
							subtitle: data.subtitle || '',
							buttonText: data.buttonText || 'Find out more',
							videoLink: data.videoLink,
							mobileMediaId: data.mobileMediaId,
						},
					});
					if (rsp.data) {
						CustomNotification({
							pageName: 'Sliders',
							pagePrefix: 'Slider',
							notificationType: 'created',
						});
						navigate(`${ROUTES.EDIT_SLIDER.path}/${rsp.data.createSlider?.id}`);
					}
				}}
			/>
		</Row>
	);
};

export default CreateSlider;
